import { column, Schema, Table } from '@powersync/common';

import { DEMO_TABLES, type DemoColumnType } from './tables';

// A new file name on purpose: op-sqlite keeps databases in the same Android
// folder WatermelonDB used for `bizplus_demo`, whose real `demo_*` tables would
// clash with the views PowerSync creates under the same names.
export const DEMO_DB_FILENAME = 'bizplus_demo_powersync.db';

const COLUMN_TYPES = {
  text: column.text,
  integer: column.integer,
  real: column.real,
} satisfies Record<DemoColumnType, unknown>;

function toLocalOnlyTable(spec: {
  columns: Record<string, DemoColumnType>;
  indexed: readonly string[];
}): Table {
  const columns = Object.fromEntries(
    Object.entries(spec.columns).map(([name, type]) => [
      name,
      COLUMN_TYPES[type],
    ]),
  );
  const indexes = Object.fromEntries(spec.indexed.map(name => [name, [name]]));
  // Demo data never syncs. Local-only tables keep writes out of the upload
  // queue (docs.powersync.com/client-sdks/advanced/local-only-usage).
  return new Table(columns, { indexes, localOnly: true });
}

export const demoSchema = new Schema(
  Object.fromEntries(
    Object.entries(DEMO_TABLES).map(([name, spec]) => [
      name,
      toLocalOnlyTable(spec),
    ]),
  ),
);
